import { Box } from "@mui/material";
import dynamic from "next/dynamic";

import aiLoader from "./ai_loader.json";

import { isChromatic } from "@/common/helpers/isChromatic";

const Lottie = dynamic(() => import("react-lottie"), { ssr: false });

interface AiLoaderProps {
  size?: "small" | "medium" | "large";
}

const HEIGHT_BY_SIZE = {
  small: 20,
  medium: 32,
  large: 56,
};

export const DashboardAiLoader = ({ size = "medium" }: AiLoaderProps) => {
  return (
    <Box
      sx={{
        height: HEIGHT_BY_SIZE[size],
        "& svg": { width: "unset !important", height: "inherit" },
      }}
    >
      <Lottie
        options={{ animationData: aiLoader, autoplay: !isChromatic() }}
        style={{ height: "inherit" }}
        ariaRole="loader"
        isClickToPauseDisabled={true}
      />
    </Box>
  );
};
